import React, {useMemo} from "react";
import DefaultType from "../../../../../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import TypeEntity from "../../../../../../../Utils/Form/FormDynamic/Fields/EntityExternal/Entity";
import SelectType from "../../../../../../../Utils/Form/FormDynamic/Fields/SelectType/Select";
import findByString from "../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";

const styles = {
    fieldStyles: {fullWidth: true},
    labelStyles: {width: 150}
};

const MinMax = ({setValue, values, disabled, type}) => {
    return (
        <>
            <DefaultType
                values={values}
                field={{
                    type: type === 'date' ? type : 'number',
                    path: 'minLength',
                    label: "Min",
                    disabled
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
            <DefaultType
                values={values}
                field={{
                    type: type === 'date' ? type : 'number',
                    path: 'maxLength',
                    label: "Max",
                    disabled
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
        </>
    )
};
const MinMaxLength = ({setValue, values, disabled}) => {
    console.log(values)
    return (
        <>
            <DefaultType
                values={values}
                field={{
                    type: 'number',
                    path: 'minLength',
                    label: "Min Length",
                    disabled
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
            <DefaultType
                values={values}
                field={{
                    type: 'number',
                    path: 'maxLength',
                    label: "Max Length",
                    disabled
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
        </>
    )
};

export const DefaultFields = ({setValue, values, disabled, nameRef, overridable}) => {
    return (
        <>
            <DefaultType
                values={values}
                field={{
                    type: 'string',
                    path: 'name',
                    label: "Name",
                    disabled
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
                customRef={nameRef}
            />
            <DefaultType
                values={values}
                field={{
                    type: 'string',
                    path: 'label',
                    label: "Label",
                    disabled: disabled ? !overridable : disabled,
                    multiLanguage: true
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
            <TypeEntity
                values={values}
                field={{
                    type: 'string',
                    path: 'type',
                    entity: "fieldType",
                    label: "Type",
                    schema: {
                        labelFields: ["name"]
                    },
                    disabled
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
        </>
    )
};
export const CommonFields = ({setValue, values = {}, disabled, overridable}) => {

    const isValueGenerator = useMemo(() => {
        return Boolean(findByString(values, 'valueGenerator'))
    }, [JSON.stringify(values)]);
    return (
        <>
            <SelectType
                values={values}
                field={{
                    type: "bool",
                    path: 'required',
                    label: "Required",
                    disabled: disabled ? !overridable : disabled,
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
            <SelectType
                values={values}
                field={{
                    type: "bool",
                    path: 'disabled',
                    label: "Disabled",
                    disabled: disabled ? !overridable : disabled,
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
            <SelectType
                values={values}
                field={{
                    type: "bool",
                    path: 'trackChanges',
                    label: "Track Changes",
                    disabled: disabled ? !overridable : disabled,
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
            <TypeEntity
                values={values}
                field={{
                    type: 'string',
                    path: 'valueGenerator',
                    entity: 'valueGenerator',
                    label: "Value Generator",
                    schema: {
                        labelFields: ['name']
                    },
                    disabled: disabled ? !overridable : disabled,
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
            <SelectType
                values={values}
                field={{
                    type: "bool",
                    path: 'valueDropdownOnly',
                    label: "Value Dropdown Only",
                    disabled: disabled ? !overridable : disabled,
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
            {
                isValueGenerator && (
                    <SelectType
                        values={values}
                        field={{
                            type: "bool",
                            path: 'generateWhenEmpty',
                            label: "Generate When Empty",
                            disabled: disabled ? !overridable : disabled,
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                )
            }
            <DefaultType
                values={values}
                field={{
                    type: 'string',
                    path: 'pattern',
                    label: "Pattern",
                    disabled: disabled ? !overridable : disabled,
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
            <TypeEntity
                values={values}
                field={{
                    type: 'string',
                    path: 'patternError',
                    entity: 'translation',
                    label: "Pattern Error",
                    schema: {
                        labelFields: ['name']
                    },
                    disabled: disabled ? !overridable : disabled,
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
            <SelectType
                values={values}
                field={{
                    type: "bool",
                    path: 'hidden',
                    label: "Hidden",
                    disabled: disabled ? !overridable : disabled,
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
            <DefaultType
                values={values}
                field={{
                    type: 'string',
                    path: 'altName',
                    label: "Alt Name",
                    disabled: disabled ? !overridable : disabled,
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
            <TypeEntity
                values={values}
                field={{
                    type: 'string',
                    path: 'helpText',
                    entity: 'helpText',
                    label: "Help Text",
                    schema: {
                        labelFields: ['id']
                    },
                    disabled: disabled ? !overridable : disabled,
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
            <SelectType
                values={values}
                field={{
                    type: "bool",
                    path: 'overridable',
                    label: "Overridable",
                    disabled
                }}
                setValue={setValue}
                labelStyles={styles.labelStyles}
                fieldStyles={styles.fieldStyles}
            />
        </>
    )
};
export const getAdditionalFields = (type, values, setValue, disabled, overridable) => {
    switch (type) {
        case 'text':
            return (
                <>
                    <SelectType
                        values={values}
                        field={{
                            type: "bool",
                            path: 'isArray',
                            label: "Is Array",
                            disabled
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                    <SelectType
                        values={values}
                        field={{
                            type: "bool",
                            path: 'multiLanguage',
                            label: "Multi Language",
                            disabled: disabled ? !overridable : disabled,
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                </>
            )
        case 'frequency':
        case 'bool':
        case 'jsonObject':
            return <></>;
        case 'integer':
        case 'date':
        case 'datetime':
        case 'time':
        case 'duration':
            return <MinMax values={values} setValue={setValue} disabled={disabled ? !overridable : disabled}
                           type={type}/>;
        case 'number':
            return (
                <>
                    <DefaultType
                        values={values}
                        field={{
                            type: 'number',
                            path: 'decimalPlaces',
                            label: "Decimal Places",
                            disabled: disabled ? !overridable : disabled,
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                    <MinMax values={values} setValue={setValue} disabled={disabled}/>
                </>
            );
        case 'string':
            return (
                <>
                    <SelectType
                        values={values}
                        field={{
                            type: "bool",
                            path: 'isArray',
                            label: "Is Array",
                            disabled
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                    <TypeEntity
                        values={values}
                        field={{
                            type: 'string',
                            path: 'dropdown',
                            entity: "screen",
                            label: "Dropdown",
                            schema: {
                                labelFields: ["name"]
                            },
                            disabled: disabled ? !overridable : disabled,
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                    <MinMaxLength
                        setValue={setValue}
                        values={values}
                        disabled={disabled ? !overridable : disabled}
                    />
                    <DefaultType
                        values={values}
                        field={{
                            type: 'string',
                            path: 'values',
                            label: "Values",
                            isArray: true,
                            disabled: disabled ? !overridable : disabled,
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                    <SelectType
                        values={values}
                        field={{
                            type: "bool",
                            path: 'multiLanguage',
                            label: "Multi Language",
                            disabled: disabled ? !overridable : disabled,
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                </>
            );
        case 'entityExternal':
            return (
                <>
                    <TypeEntity
                        values={values}
                        field={{
                            type: 'string',
                            path: 'entity',
                            entity: "schema",
                            label: "Entity",
                            schema: {
                                labelFields: ["name"]
                            },
                            disabled: disabled ? !overridable : disabled,
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                    <SelectType
                        values={values}
                        field={{
                            type: "bool",
                            path: 'isArray',
                            label: "Is Array",
                            disabled
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                    <TypeEntity
                        values={values}
                        field={{
                            type: 'string',
                            path: 'dropdown',
                            entity: "screen",
                            label: "Dropdown",
                            schema: {
                                labelFields: ["name"]
                            },
                            disabled: disabled ? !overridable : disabled,
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                    <SelectType
                        values={values}
                        field={{
                            type: "bool",
                            path: 'restrictCreate',
                            label: "Restrict Create",
                            disabled: disabled ? !overridable : disabled,
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                </>
            );
        case 'entityMixed':
        case 'entityEmbedded':
            return (
                <>
                    <TypeEntity
                        values={values}
                        field={{
                            type: 'string',
                            path: 'entity',
                            entity: "schema",
                            label: "Entity",
                            schema: {
                                labelFields: ["name"]
                            },
                            disabled: disabled ? !overridable : disabled,
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                    <SelectType
                        values={values}
                        field={{
                            type: "bool",
                            path: 'isArray',
                            label: "Is Array",
                            disabled
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                    <SelectType
                        values={values}
                        field={{
                            type: "objSelect",
                            path: 'arrayType',
                            label: "Array Type",
                            values: [
                                {value: "vertical", label: "Vertical"},
                                {value: "horizontal", label: "Horizontal"},
                            ],
                            disabled: disabled ? !overridable : disabled,
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                    <SelectType
                        values={values}
                        field={{
                            type: "bool",
                            path: 'checkChildrenOnNull',
                            label: "Check children on null",
                            disabled
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                </>
            );
        case 'object':
            return (
                <>
                    <SelectType
                        values={values}
                        field={{
                            type: "bool",
                            path: 'isArray',
                            label: "Is Array",
                            disabled
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                    <SelectType
                        values={values}
                        field={{
                            type: "objSelect",
                            path: 'arrayType',
                            label: "Array Type",
                            values: [
                                {value: "vertical", label: "Vertical"},
                                {value: "horizontal", label: "Horizontal"},
                            ],
                            disabled
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                    <SelectType
                        values={values}
                        field={{
                            type: "bool",
                            path: 'checkChildrenOnNull',
                            label: "Check children on null",
                            disabled
                        }}
                        setValue={setValue}
                        labelStyles={styles.labelStyles}
                        fieldStyles={styles.fieldStyles}
                    />
                </>
            )
    }
};